<template>
  <div class="content">
    <a-row>
      <a-col :span="18">
        <div class="nav">
          <ul>
            <router-link to="/detail">
              <li :class="data.active == 1 ? 'action' : ''" @click="active(1)">
                基站信息
              </li>
            </router-link>
            <router-link to="/detail/dianchi">
              <li :class="data.active == 2 ? 'action' : ''" @click="active(2)">
                电池管理(BMS)
              </li>
            </router-link>
            <router-link to="/detail/gaojing">
              <li :class="data.active == 3 ? 'action' : ''" @click="active(3)">
                告警记录
              </li>
            </router-link>
            <router-link to="/detail/chuneng">
              <li :class="data.active == 4 ? 'action' : ''" @click="active(4)">
                能源管理(EMS)
              </li>
            </router-link>
            <router-link to="/detail/dianyuan">
              <li :class="data.active == 5 ? 'action' : ''" @click="active(5)">
                电源管理
              </li>
            </router-link>
            <router-link to="/detail/guangfu">
              <li :class="data.active == 6 ? 'action' : ''" @click="active(6)">
                光伏/风电
              </li>
            </router-link>
            <router-link to="/detail/donghuan">
              <li :class="data.active == 7 ? 'action' : ''" @click="active(7)">
                动环
              </li>
            </router-link>
          </ul>
        </div>
      </a-col>
      <a-col :span="6" v-if="data.active == 1">
        <div class="peizhi">
          <ul>
            <li @click="showModal11">配置</li>
            <li @click="showModal12">升级</li>
            <li @click="showModal">电源设置</li>
            <li @click="showModal13">策略设置</li>
            <li style="margin-right: 0" @click="showModal15">保护设置</li>
          </ul>
        </div>
      </a-col>
      <a-col :span="6" v-if="data.active == 2">
        <div class="peizhi" style="padding-left: 150px">
          <ul>
            <li @click="showModal2">电池设置</li>
          </ul>
        </div>
      </a-col>
    </a-row>

    <router-view />
  </div>

  <a-modal v-model:visible="visible11" width="800px" title="配置" @ok="handleOk11" :closable="false" cancelText="取消"
    okText="确定" :bodyStyle="{
      color: '#fff',
      background: '#0d2a4b',
      borderbottom: '1px #2b85e4 solid',
    }">
    <div>
      <a-form :model="peizhi" name="basic" autocomplete="off" layout="vertical">
        <a-tabs v-model:activeKey="activeKey">
          <a-tab-pane :key="0" tab="电池配置">
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item label="站点工作模式">
                  <a-select v-model:value="peizhi.workMode">
                    <a-select-option :value="0">储备模式</a-select-option>
                    <a-select-option :value="1">纯备电模式</a-select-option>
                    <a-select-option :value="2">测维模式</a-select-option>
                    <a-select-option :value="3">光伏储备模式</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="电池厂家">
                  <a-input v-model:value="peizhi.batteryFactory" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="电池配置规格" class="input-group">
                  <a-input placeholder="电芯串数量" v-model:value="peizhi.batterySerialParallelNum" style="width: 180px" />
                  <span style="margin: 0 20px; color: #fff">X</span>
                  <a-input placeholder="电芯并数量" v-model:value="peizhi.batteryCellParallelNum" style="width: 180px" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="电池包串联数量">
                  <a-input v-model:value="peizhi.batterySerialNum" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="电池包并联数量">
                  <a-input v-model:value="peizhi.batteryParallelNum" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="电池包数量">
                  <a-input v-model:value="peizhi.packageNum" disabled placeholder="电池包串联*电池包并联" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="电池类型">
                  <a-select v-model:value="peizhi.batteryType">
                    <a-select-option :value="0">磷酸铁锂电池</a-select-option>
                    <a-select-option :value="1">其他</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="电池新旧程度">
                  <a-radio-group v-model:value="peizhi.batteryDegree">
                    <a-radio :value="0">旧电池</a-radio>
                    <a-radio :value="1">新电池</a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="均衡电阻">
                  <a-input v-model:value="peizhi.balanceResistance" addon-after="Ω" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="电池协议版本">
                  <a-input v-model:value="peizhi.batteryProtocol" />
                </a-form-item>
              </a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane :key="1" tab="电源配置">
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item label="电源厂家">
                  <a-input v-model:value="peizhi.switchFactory" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="电源种类选择">
                  <a-select v-model:value="peizhi.powerType">
                    <a-select-option :value="0">请选择种类</a-select-option>
                    <a-select-option :value="1">48V通信电源</a-select-option>
                    <a-select-option :value="2">直流屏</a-select-option>
                    <a-select-option :value="3">UPS工频机</a-select-option>
                    <a-select-option :value="4">UPS高频机</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="电源协议版本">
                  <a-input v-model:value="peizhi.powerProtocol" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="额定安时电容">
                  <a-input v-model:value="peizhi.ratedCapacity" addon-after="Ah" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="充电安时电容">
                  <a-input v-model:value="peizhi.chargeCapacity" addon-after="Ah" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="放电安时电容">
                  <a-input v-model:value="peizhi.dischargeCapacity" addon-after="Ah" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="系统配置时间">
                  <a-input v-model:value="peizhi.createdAt" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="主从SC总数目">
                  <a-input v-model:value="peizhi.scNum" />
                </a-form-item>
              </a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane :key="2" tab="串口配置">
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item label="后台485口地址">
                  <a-input v-model:value="peizhi.address485" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="后台485口协议">
                  <a-select v-model:value="peizhi.protocol485">
                    <a-select-option :value="0">modbus从站协议</a-select-option>
                    <a-select-option :value="1">modbus主站协议</a-select-option>
                    <a-select-option :value="2">电总接收协议</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="后台RS485口波特率">
                  <a-select v-model:value="peizhi.bps485">
                    <a-select-option :value="0">9600</a-select-option>
                    <a-select-option :value="1">19200</a-select-option>
                    <a-select-option :value="2">38400</a-select-option>
                    <a-select-option :value="3">57600</a-select-option>
                    <a-select-option :value="4">115200</a-select-option>
                    <a-select-option :value="5">921600</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="后台RS485口数据位">
                  <a-select v-model:value="peizhi.bit485">
                    <a-select-option :value="0">8位</a-select-option>
                    <a-select-option :value="1">9位</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="后台RS485口停止位">
                  <a-select v-model:value="peizhi.stopBit485">
                    <a-select-option :value="0">1位</a-select-option>
                    <a-select-option :value="1">1.5位</a-select-option>
                    <a-select-option :value="2">2位</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="后台RS485口校验">
                  <a-select v-model:value="peizhi.verify485">
                    <a-select-option :value="0">无校验</a-select-option>
                    <a-select-option :value="1">奇校验</a-select-option>
                    <a-select-option :value="2">偶校验</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="启用RS485端口">
                  <a-radio-group v-model:value="peizhi.enable485">
                    <a-radio value="ENABLE"><span style="color: #fff">开启</span></a-radio>
                    <a-radio value="DISABLE"><span style="color: #fff">关闭</span></a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
            </a-row>
          </a-tab-pane>
        </a-tabs>
      </a-form>
    </div>
  </a-modal>

  <a-modal v-model:visible="visible12" width="400px" title="升级" @ok="handleOk12" :closable="false" cancelText="取消"
    okText="确定" :bodyStyle="{
      color: '#fff',
      background: '#0d2a4b',
      borderbottom: '1px #2b85e4 solid',
    }">
    <div>
      <a-form :model="formState12" name="basic" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" autocomplete="off">
        <a-row :gutter="24">
          <div style="padding-left: 130px;">
            <div>
              <a-upload v-model:file-list="fileList" :maxCount="1"
                action="http://api.chuneng.xg360.cc/base_station/firmware" name="file" :headers="headers"
                list-type="picture-card" @change="handleChange">

                <loading-outlined v-if="loading"></loading-outlined>
                <plus-outlined :style="{ fontSize: '36px', color: '#666', display: 'block' }" v-else></plus-outlined>
                <div class="ant-upload-text">上传固件程序</div>
              </a-upload>
            </div>
          </div>
        </a-row>
      </a-form>
    </div>
  </a-modal>

  <a-modal v-model:visible="visible" width="800px" title="电源设置" @ok="handleOk" :closable="false" cancelText="取消"
    okText="确定" :bodyStyle="{
      color: '#fff',
      background: '#0d2a4b',
      borderbottom: '1px #2b85e4 solid',
    }">
    <div>
      <a-form :model="dianyuan" name="basic" layout="vertical" autocomplete="off">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="直流电压上限">
              <a-input v-model:value="dianyuan.directVoltageUpper" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="直流电压下限">
              <a-input v-model:value="dianyuan.directVoltageLower" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="充电限流值">
              <a-input v-model:value="dianyuan.chargeCurrent" addon-after="C" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </a-modal>

  <a-modal v-model:visible="visible13" width="800px" title="策略设置" @ok="handleOk13" :closable="false" cancelText="取消"
    okText="确定" :bodyStyle="{
      color: '#fff',
      background: '#0d2a4b',
      borderbottom: '1px #2b85e4 solid',
    }">
    <div>
      <a-form :model="clsz" name="basic" autocomplete="off" layout="vertical">
        <a-tabs v-model:activeKey="activeKey">
          <a-tab-pane :key="0" tab="备电时间">
            <a-row :gutter="24" class="dcpz">
              <a-col :span="12">
                <a-form-item label="差异化备电个数">
                  <a-input v-model:value="clsz.diffSlaveNum" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="最低备电时间T1min">
                  <a-input v-model:value="clsz.t1Min" addon-after="分钟" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="最低备电时间T2min">
                  <a-input v-model:value="clsz.t2Min" addon-after="分钟" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="最低备电时间T3min">
                  <a-input v-model:value="clsz.t3Min" addon-after="分钟" />
                </a-form-item>
              </a-col>

              <a-col :span="12">
                <a-form-item label="最低备电时间T4min">
                  <a-input v-model:value="clsz.t4Min" addon-after="分钟" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="最低备电时间T5min">
                  <a-input v-model:value="clsz.t5Min" addon-after="分钟" />
                </a-form-item>
              </a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane :key="1" tab="负载占比">
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item label="T1min的负载占比">
                  <a-input v-model:value="clsz.t1LoadPercent" addon-after="%" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="T2min的负载占比">
                  <a-input v-model:value="clsz.t2LoadPercent" addon-after="%" />
                </a-form-item>
              </a-col>

              <a-col :span="12">
                <a-form-item label="T3min的负载占比">
                  <a-input v-model:value="clsz.t3LoadPercent" addon-after="%" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="T4min的负载占比">
                  <a-input v-model:value="clsz.t4LoadPercent" addon-after="%" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="T5min的负载占比">
                  <a-input v-model:value="clsz.t5LoadPercent" addon-after="%" />
                </a-form-item>
              </a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane :key="2" tab="时段设置">
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item label="峰谷段使能">
                  <a-radio-group v-model:value="clsz.peakValleyEnable">
                    <a-radio value="ENABLE"><span style="color: #fff">使能</span></a-radio>
                    <a-radio value="DISABLE"><span style="color: #fff">不使能</span></a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="开启尖峰">
                  <a-radio-group v-model:value="clsz.topEnable">
                    <a-radio value="ENABLE"><span style="color: #fff">使能</span></a-radio>
                    <a-radio value="DISABLE"><span style="color: #fff">不使能</span></a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="尖峰月份">
                  <a-input v-model:value="clsz.topMonthes" addon-after="月" />
                </a-form-item>
              </a-col>

              <a-col :span="8">
                <a-form-item label="后台调控充电量">
                  <a-input v-model:value="clsz.chargeControl" addon-after="kWh" />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="后台调控放电量">
                  <a-input v-model:value="clsz.dischargeControl" addon-after="kWh" />
                </a-form-item>
              </a-col>


              <a-col :span="8" style="margin-bottom: 20px">
                <a-form-item label="峰段1开始时间">
                  <a-space direction="vertical" :size="12">
                    <a-date-picker show-time placeholder="选择时间" v-model:value="clsz.peak1DatetimeStart"
                      @change="onChange" @ok="onOk" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" />

                  </a-space>
                </a-form-item>

              </a-col>

              <a-col :span="8" style="margin-bottom: 20px">
                <a-form-item label="峰段1结束时间">

                  <a-space direction="vertical" :size="12">
                    <a-date-picker show-time placeholder="选择时间" v-model:value="clsz.peak1DatetimeEnd"
                      @change="onChange2" @ok="onOk2" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" />
                  </a-space>
                </a-form-item>
              </a-col>

              <a-col :span="8" style="margin-bottom: 20px">
                <a-form-item label="谷段1开始时间">

                  <a-space direction="vertical" :size="12">
                    <a-date-picker show-time placeholder="选择时间" v-model:value="clsz.valley1DatetimeStart"
                      @change="onChange5" @ok="onOk5" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" />

                  </a-space>
                </a-form-item>

              </a-col>

              <a-col :span="8" style="margin-bottom: 20px">
                <a-form-item label="谷段1结束时间">

                  <a-space direction="vertical" :size="12">
                    <a-date-picker show-time placeholder="选择时间" v-model:value="clsz.valley1DatetimeEnd"
                      @change="onChange6" @ok="onOk6" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" />
                  </a-space>
                </a-form-item>
              </a-col>
              <a-col :span="8" style="margin-bottom: 20px">
                <a-form-item label="尖峰1开始时间">

                  <a-space direction="vertical" :size="12">
                    <a-date-picker show-time placeholder="选择时间" v-model:value="clsz.top1DatetimeStart"
                      @change="onChange9" @ok="onOk9" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" />

                  </a-space>
                </a-form-item>

              </a-col>

              <a-col :span="8" style="margin-bottom: 20px">
                <a-form-item label="尖峰1结束时间">

                  <a-space direction="vertical" :size="12">
                    <a-date-picker show-time placeholder="选择时间" v-model:value="clsz.top1DatetimeEnd"
                      @change="onChange10" @ok="onOk10" format="YYYY-MM-DD HH:mm:ss"
                      valueFormat="YYYY-MM-DD HH:mm:ss" />
                  </a-space>
                </a-form-item>
              </a-col>

              <a-col :span="8" style="margin-bottom: 20px">
                <a-form-item label="特别峰段1开始时间">

                  <a-space direction="vertical" :size="12">
                    <a-date-picker show-time placeholder="选择时间" v-model:value="clsz.specialPeak1DatetimeStart"
                      @change="onChange13" @ok="onOk13" format="YYYY-MM-DD HH:mm:ss"
                      valueFormat="YYYY-MM-DD HH:mm:ss" />

                  </a-space>
                </a-form-item>

              </a-col>

              <a-col :span="8" style="margin-bottom: 20px">
                <a-form-item label="特别封峰1结束时间">

                  <a-space direction="vertical" :size="12">
                    <a-date-picker show-time placeholder="选择时间" v-model:value="clsz.specialPeak1DatetimeEnd"
                      @change="onChange14" @ok="onOk14" format="YYYY-MM-DD HH:mm:ss"
                      valueFormat="YYYY-MM-DD HH:mm:ss" />
                  </a-space>
                </a-form-item>
              </a-col>
              <a-col :span="8" style="margin-bottom: 20px">
                <a-form-item label="峰段2开始时间">

                  <a-space direction="vertical" :size="12">
                    <a-date-picker show-time placeholder="选择时间" v-model:value="clsz.peak2DatetimeStart"
                      @change="onChange4" @ok="onOk4" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" />

                  </a-space>
                </a-form-item>

              </a-col>

              <a-col :span="8" style="margin-bottom: 20px">
                <a-form-item label="峰段2结束时间">

                  <a-space direction="vertical" :size="12">
                    <a-date-picker show-time placeholder="选择时间" v-model:value="clsz.peak2DatetimeEnd"
                      @change="onChange3" @ok="onOk3" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" />
                  </a-space>
                </a-form-item>
              </a-col>



              <a-col :span="8" style="margin-bottom: 20px">
                <a-form-item label="谷段2开始时间">

                  <a-space direction="vertical" :size="12">
                    <a-date-picker show-time placeholder="选择时间" v-model:value="clsz.valley2DatetimeStart"
                      @change="onChange7" @ok="onOk7" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" />

                  </a-space>
                </a-form-item>

              </a-col>

              <a-col :span="8" style="margin-bottom: 20px">
                <a-form-item label="谷段2结束时间">

                  <a-space direction="vertical" :size="12">
                    <a-date-picker show-time placeholder="选择时间" v-model:value="clsz.valley2DatetimeEnd"
                      @change="onChange8" @ok="onOk8" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" />
                  </a-space>
                </a-form-item>
              </a-col>



              <a-col :span="8" style="margin-bottom: 20px">
                <a-form-item label="尖峰2开始时间">

                  <a-space direction="vertical" :size="12">
                    <a-date-picker show-time placeholder="选择时间" v-model:value="clsz.top2DatetimeStart"
                      @change="onChange11" @ok="onOk11" format="YYYY-MM-DD HH:mm:ss"
                      valueFormat="YYYY-MM-DD HH:mm:ss" />

                  </a-space>
                </a-form-item>

              </a-col>

              <a-col :span="8" style="margin-bottom: 20px">
                <a-form-item label="尖峰2结束时间">

                  <a-space direction="vertical" :size="12">
                    <a-date-picker show-time placeholder="选择时间" v-model:value="clsz.top2DatetimeEnd"
                      @change="onChange12" @ok="onOk12" format="YYYY-MM-DD HH:mm:ss"
                      valueFormat="YYYY-MM-DD HH:mm:ss" />
                  </a-space>
                </a-form-item>
              </a-col>



              <a-col :span="8" style="margin-bottom: 20px">
                <a-form-item label="特别峰段2开始时间">

                  <a-space direction="vertical" :size="12">
                    <a-date-picker show-time placeholder="选择时间" v-model:value="clsz.specialPeak2DatetimeStart"
                      @change="onChange15" @ok="onOk15" format="YYYY-MM-DD HH:mm:ss"
                      valueFormat="YYYY-MM-DD HH:mm:ss" />

                  </a-space>
                </a-form-item>

              </a-col>

              <a-col :span="8" style="margin-bottom: 20px">
                <a-form-item label="特别封峰2结束时间">

                  <a-space direction="vertical" :size="12">
                    <a-date-picker show-time placeholder="选择时间" v-model:value="clsz.specialPeak2DatetimeEnd"
                      @change="onChange16" @ok="onOk16" format="YYYY-MM-DD HH:mm:ss"
                      valueFormat="YYYY-MM-DD HH:mm:ss" />
                  </a-space>
                </a-form-item>
              </a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane :key="3" tab="电价设置">
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item label="正常月份电价">
                  <a-input v-model:value="clsz.monthPrice" addon-after="元" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="尖峰月份电价">
                  <a-input v-model:value="clsz.peakMonthPrice" addon-after="元" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="尖峰月份尖峰电价">
                  <a-input v-model:value="clsz.peakPeakPrice" addon-after="元" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="尖峰月份谷段电价">
                  <a-input v-model:value="clsz.peakValleyPrice" addon-after="元" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="尖峰段1电价">
                  <a-input v-model:value="clsz.peak1Price" addon-after="元" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="尖峰段2电价">
                  <a-input v-model:value="clsz.peak2Price" addon-after="元" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="平段电价1">
                  <a-input v-model:value="clsz.flat1Price" addon-after="元" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="平段电价2">
                  <a-input v-model:value="clsz.flat2Price" addon-after="元" />
                </a-form-item>
              </a-col>

            </a-row>
          </a-tab-pane>
        </a-tabs>
      </a-form>
    </div>
  </a-modal>

  <a-modal v-model:visible="visible15" width="800px" title="保护设置" @ok="handleOk15" :closable="false" cancelText="取消"
    okText="确定" :bodyStyle="{
      color: '#fff',
      background: '#0d2a4b',
      borderbottom: '1px #2b85e4 solid',
    }">
    <div>
      <a-form :model="baohu" name="basic" autocomplete="off" layout="vertical">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="第一次运行标志">
              <a-input v-model:value="baohu.firstFlag" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="充放电循环次数">
              <a-input v-model:value="baohu.dischargeCycleNum" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="放电总压低告警">
              <a-input v-model:value="baohu.dischargeSingleProtect" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="充电总压高保护">
              <a-input v-model:value="baohu.chargeSingleVoltage" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="放电限流">
              <a-input v-model:value="baohu.dischargeLimit" addon-after="C" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="充电过流保护">
              <a-input v-model:value="baohu.chargeLimit" addon-after="C" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="放电判断电流阈值">
              <a-input v-model:value="baohu.dischargeThreshold" addon-after="C" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="充电流判断阈值">
              <a-input v-model:value="baohu.chargeThreshold" addon-after="C" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="内阻计算周期">
              <a-input v-model:value="baohu.internalResistance" addon-after="月" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="充电安时效率">
              <a-input v-model:value="baohu.chargeCurrentRatio" addon-after="%" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="寿命终止SOH">
              <a-input v-model:value="baohu.deadSoh" addon-after="%" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="充放电延时">
              <a-input v-model:value="baohu.chargeDischargeDelay" addon-after="分钟" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="放电总压保护">
              <a-input v-model:value="baohu.dischargeProtect" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="充电总压保护">
              <a-input v-model:value="baohu.chargeProtect" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="核对性放电周期">
              <a-input v-model:value="baohu.dischargeCycle" addon-after="年" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="纯备电检测周期">
              <a-input v-model:value="baohu.slaveCheckCycle" addon-after="月" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="电池连接检查周期">
              <a-input v-model:value="baohu.batteryCheckCycle" addon-after="月" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </a-modal>

  <a-modal v-model:visible="visible2" width="800px" title="电池设置" @ok="handleOk2" :closable="false" cancelText="取消"
    okText="确定" :bodyStyle="{
      color: '#fff',
      background: '#0d2a4b',
      borderbottom: '1px #2b85e4 solid',
    }">
    <div>
      <a-form :model="formState3" name="basic" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" autocomplete="off"
        @finish="onFinish2" @finishFailed="onFinishFailed">
        <a-row :gutter="24" class="dcpz">
          <a-col :span="12">
            <a-form-item label="单体电压上限" name="username">
              <a-input v-model:value="formState2.username" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="单体电压下限" name="password">
              <a-input v-model:value="formState2.password" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="温度上限" name="password">
              <a-input v-model:value="formState2.password" addon-after="°C" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="温度下限" name="password">
              <a-input v-model:value="formState2.password" addon-after="°C" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="总电压上限" name="username">
              <a-input v-model:value="formState2.username" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="总电压下限" name="password">
              <a-input v-model:value="formState2.password" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="充电电流上限" name="password">
              <a-input v-model:value="formState2.password" addon-after="A" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="放电过流保护值" name="password">
              <a-input v-model:value="formState2.password" addon-after="A" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="充电过流告警值" name="username">
              <a-input v-model:value="formState2.username" addon-after="A" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="放电过流告警值" name="password">
              <a-input v-model:value="formState2.password" addon-after="A" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="单体过充恢复电压值" name="password">
              <a-input v-model:value="formState2.password" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="单体过压告警值" name="password">
              <a-input v-model:value="formState2.password" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="单体过放恢复电压值" name="username">
              <a-input v-model:value="formState2.username" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="单体欠压告警值" name="password">
              <a-input v-model:value="formState2.password" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开始均衡电压" name="password">
              <a-input v-model:value="formState2.password" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="均衡压差" name="password">
              <a-input v-model:value="formState2.password" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="总过压恢复电压值" name="username">
              <a-input v-model:value="formState2.username" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="总过压告警电压值" name="password">
              <a-input v-model:value="formState2.password" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="总欠压恢复电压值" name="password">
              <a-input v-model:value="formState2.password" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="总欠压告警电压值" name="password">
              <a-input v-model:value="formState2.password" addon-after="V" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="放电过温告警值" name="username">
              <a-input v-model:value="formState2.username" addon-after="°C" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="放电过温恢复温度值" name="password">
              <a-input v-model:value="formState2.password" addon-after="°C" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="放电欠温告警值" name="password">
              <a-input v-model:value="formState2.password" addon-after="°C" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="放电欠温恢复温度值" name="password">
              <a-input v-model:value="formState2.password" addon-after="°C" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="充电过温值" name="username">
              <a-input v-model:value="formState2.username" addon-after="°C" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="充电过温告警值" name="password">
              <a-input v-model:value="formState2.password" addon-after="°C" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="充电过温恢复温度值" name="password">
              <a-input v-model:value="formState2.password" addon-after="°C" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="充电欠温值" name="password">
              <a-input v-model:value="formState2.password" addon-after="°C" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="充电欠温告警值" name="username">
              <a-input v-model:value="formState2.username" addon-after="°C" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="充电欠温恢复温度值" name="password">
              <a-input v-model:value="formState2.password" addon-after="°C" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
import * as moment from 'moment';
import dayjs from 'dayjs';
import { message } from 'ant-design-vue';
import http from "@/api/http";
import { defineComponent, reactive, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons-vue';
export default defineComponent({
  name: "XiangQing",
  components: {
    LoadingOutlined,
    PlusOutlined,
  },
  props: {},

  setup() {
    const store = useStore()

    const fileList = ref([]);
    const headers = ref({
      authorization: 'Bearer ' + store.getters['User/token']
    });
    const uploads = ref('display:blok')
    const activeKey = ref(0);
    const handleChange = (value) => {
      console.log(value);
      if (value.file.status !== 'uploading') {
        console.log(value.file, value.fileList);
      }
      if (value.file.status === 'done') {
        message.success(`${value.file.name} 上传成功`);
        uploads.value = 'display:none'
      } else if (value.file.status === 'error') {
        message.error(`${value.file.name} 上传失败`);
      }
    };
    const onChange = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    };
    const onOk = (value) => {
      console.log('onOk: ', value);
    };

    const onChange2 = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    };
    const onOk2 = (value) => {
      console.log('onOk: ', value);
    };

    const onChange3 = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    };
    const onOk3 = (value) => {
      console.log('onOk: ', value);
    };

    const onChange4 = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    };
    const onOk4 = (value) => {
      console.log('onOk: ', value);
    };

    const onChange5 = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    };
    const onOk5 = (value) => {
      console.log('onOk: ', value);
    };
    const onChange6 = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    };
    const onOk6 = (value) => {
      console.log('onOk: ', value);
    };
    const onChange7 = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    };
    const onOk7 = (value) => {
      console.log('onOk: ', value);
    };
    const onChange8 = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    };
    const onOk8 = (value) => {
      console.log('onOk: ', value);
    };
    const onChange9 = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    };
    const onOk9 = (value) => {
      console.log('onOk: ', value);
    };
    const onChange10 = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    };
    const onOk10 = (value) => {
      console.log('onOk: ', value);
    };
    const onChange11 = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    };
    const onOk11 = (value) => {
      console.log('onOk: ', value);
    };
    const onChange12 = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    };
    const onOk12 = (value) => {
      console.log('onOk: ', value);
    };
    const onChange13 = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    };
    const onOk13 = (value) => {
      console.log('onOk: ', value);
    };
    const onChange14 = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    };
    const onOk14 = (value) => {
      console.log('onOk: ', value);
    };
    const onChange15 = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    };
    const onOk15 = (value) => {
      console.log('onOk: ', value);
    };
    const onChange16 = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
    };
    const onOk16 = (value) => {
      console.log('onOk: ', value);
    };

    const dateFormat = 'YYYY-MM-DD HH:mm:ss';


    let data = ref({
      active: 1,
    });
    let stationid = store.getters['User/stationid']
    const active = (e) => {
      data.value.active = e;
    };

    const visible = ref(false);
    const visible2 = ref(false);

    const visible12 = ref(false);

    const visible11 = ref(false);

    const visible13 = ref(false);

    const visible15 = ref(false);

    const showModal = () => {
      visible.value = true;
    };

    const showModal2 = () => {
      visible2.value = true;
    };

    const showModal11 = () => {
      visible11.value = true;
    };

    const showModal12 = () => {
      visible12.value = true;
    };

    const showModal13 = () => {
      console.log(clsz.value)
      visible13.value = true;
    };

    const showModal15 = () => {
      visible15.value = true;
    };

    const handleOk = () => {
      http.put("/base_station_power", dianyuan.value).then(() => {
        message.success('电源设置修改成功');
      });
      visible.value = false;
    };

    const handleOk2 = (e) => {
      console.log(e);
      visible2.value = false;
    };




    const handleOk12 = (e) => {
      console.log(e);
      visible12.value = false;
    };

    const handleOk13 = () => {
      clsz.value.peak1DatetimeStart = moment(clsz.value.peak1DatetimeStart).format('YYYY-MM-DD HH:mm:ss')
      clsz.value.peak1DatetimeEnd = moment(clsz.value.peak1DatetimeEnd).format('YYYY-MM-DD HH:mm:ss')

      clsz.value.peak2DatetimeStart = moment(clsz.value.peak2DatetimeStart).format('YYYY-MM-DD HH:mm:ss')
      clsz.value.peak2DatetimeEnd = moment(clsz.value.peak2DatetimeEnd).format('YYYY-MM-DD HH:mm:ss')
      clsz.value.valley1DatetimeStart = moment(clsz.value.valley1DatetimeStart).format('YYYY-MM-DD HH:mm:ss')
      clsz.value.valley1DatetimeEnd = moment(clsz.value.valley1DatetimeEnd).format('YYYY-MM-DD HH:mm:ss')
      clsz.value.valley2DatetimeStart = moment(clsz.value.valley2DatetimeStart).format('YYYY-MM-DD HH:mm:ss')
      clsz.value.valley2DatetimeEnd = moment(clsz.value.valley2DatetimeEnd).format('YYYY-MM-DD HH:mm:ss')
      clsz.value.top1DatetimeStart = moment(clsz.value.top1DatetimeStart).format('YYYY-MM-DD HH:mm:ss')
      clsz.value.top1DatetimeEnd = moment(clsz.value.top1DatetimeEnd).format('YYYY-MM-DD HH:mm:ss')
      clsz.value.top2DatetimeStart = moment(clsz.value.top2DatetimeStart).format('YYYY-MM-DD HH:mm:ss')
      clsz.value.top2DatetimeEnd = moment(clsz.value.top2DatetimeEnd).format('YYYY-MM-DD HH:mm:ss')
      clsz.value.specialPeak1DatetimeStart = moment(clsz.value.specialPeak1DatetimeStart).format('YYYY-MM-DD HH:mm:ss')
      clsz.value.specialPeak1DatetimeEnd = moment(clsz.value.specialPeak1DatetimeEnd).format('YYYY-MM-DD HH:mm:ss')
      clsz.value.specialPeak2DatetimeStart = moment(clsz.value.specialPeak2DatetimeStart).format('YYYY-MM-DD HH:mm:ss')
      clsz.value.specialPeak2DatetimeEnd = moment(clsz.value.specialPeak2DatetimeEnd).format('YYYY-MM-DD HH:mm:ss')

      http.put("/peak_valley_setting", clsz.value).then(() => {
        message.success('策略设置修改成功');
      });
      visible13.value = false;
    };

    const handleOk15 = () => {
      http.put("/protect_setting", baohu.value).then(() => {
        message.success('保护设置修改成功');
      });
      visible15.value = false;
    };



    const peizhi = ref({
      id: "",
      stationNo: "",
      useFor: "",
      cityId: "",
      cityName: "",
      groupId: "",
      name: "",
      workMode: "0",
      batteryFactory: "",
      switchFactory: "",
      batterySerialParallelNum: "",
      batteryCellParallelNum: "",
      batteryParallelNum: "",
      batterySerialNum: "",
      packageNum: "",
      batteryType: "",
      batteryDegree: "",
      powerType: "",
      balanceResistance: "",
      batteryProtocol: "",
      powerProtocol: "",
      dischargeCapacity: "",
      chargeCapacity: "",
      ratedCapacity: "",
      createdAt: "",
      scNum: "",
      enable485: "ENABLE",
      address485: "",
      protocol485: "",
      verify485: "",
      stopBit485: "",
      bit485: "",
      bps485: ""
    });

    const clsz = ref({})
    const dianyuan = ref({})
    const baohu = ref({})

    const handleOk11 = () => {

      http.put("/base_station", peizhi.value).then(() => {
        message.success('配置成功');
      });
      visible11.value = false;
    };

    const formState2 = reactive({
      username: "",
      password: "",
      remember: true,
    });

    const formState3 = reactive({
      username: "",
      password: "",
      remember: true,
    });

    const formState11 = reactive({});
    const formState12 = reactive({});
    const formState13 = reactive({});
    const formState15 = reactive({});

    const getData = () => {
      //获取保护设置
      http.get("/protect_setting/" + stationid).then(res => {

        baohu.value = res.data

      });
      //获取电源配置
      http.get("/base_station/" + stationid + "/power").then(res => {
        dianyuan.value = res.data

      });

      //获取策略设置
      http.get("/peak_valley_setting/" + stationid).then(res => {


        clsz.value = res.data

        clsz.value.peak1DatetimeStart = dayjs(res.data.peak1DatetimeStart, dateFormat)
        clsz.value.peak1DatetimeEnd = dayjs(res.data.peak1DatetimeEnd, dateFormat)
        clsz.value.peak2DatetimeStart = dayjs(res.data.peak2DatetimeStart, dateFormat)
        clsz.value.peak2DatetimeEnd = dayjs(res.data.peak2DatetimeEnd, dateFormat)
        clsz.value.valley1DatetimeStart = dayjs(res.data.valley1DatetimeStart, dateFormat)
        clsz.value.valley1DatetimeEnd = dayjs(res.data.valley1DatetimeEnd, dateFormat)
        clsz.value.valley2DatetimeStart = dayjs(res.data.valley2DatetimeStart, dateFormat)
        clsz.value.valley2DatetimeEnd = dayjs(res.data.valley2DatetimeEnd, dateFormat)
        clsz.value.top1DatetimeStart = dayjs(res.data.top1DatetimeStart, dateFormat)
        clsz.value.top1DatetimeEnd = dayjs(res.data.top1DatetimeEnd, dateFormat)
        clsz.value.top2DatetimeStart = dayjs(res.data.top2DatetimeStart, dateFormat)
        clsz.value.top2DatetimeEnd = dayjs(res.data.top2DatetimeEnd, dateFormat)
        clsz.value.specialPeak1DatetimeStart = dayjs(res.data.specialPeak1DatetimeStart, dateFormat)
        clsz.value.specialPeak1DatetimeEnd = dayjs(res.data.specialPeak1DatetimeEnd, dateFormat)
        clsz.value.specialPeak2DatetimeStart = dayjs(res.data.specialPeak2DatetimeStart, dateFormat)
        clsz.value.specialPeak2DatetimeEnd = dayjs(res.data.specialPeak2DatetimeEnd, dateFormat)





      });

      http.get("/base_station/" + stationid + "/setting").then(res => {

        peizhi.value.id = res.data.id
        peizhi.value.stationNo = res.data.stationNo
        peizhi.value.useFor = res.data.useFor
        peizhi.value.cityId = res.data.cityId
        peizhi.value.cityName = res.data.cityName
        peizhi.value.groupId = res.data.groupId
        peizhi.value.name = res.data.name

        peizhi.value.workMode = res.data.workMode
        peizhi.value.batteryFactory = res.data.batteryFactory
        peizhi.value.switchFactory = res.data.switchFactory
        peizhi.value.batterySerialParallelNum = res.data.batterySerialParallelNum
        peizhi.value.batteryCellParallelNum = res.data.batteryCellParallelNum
        peizhi.value.batteryParallelNum = res.data.batteryParallelNum
        peizhi.value.batterySerialNum = res.data.batterySerialNum
        peizhi.value.packageNum = res.data.packageNum
        peizhi.value.batteryType = res.data.batteryType
        peizhi.value.batteryDegree = res.data.batteryDegree
        peizhi.value.powerType = res.data.powerType
        peizhi.value.balanceResistance = res.data.balanceResistance
        peizhi.value.batteryProtocol = res.data.batteryProtocol
        peizhi.value.powerProtocol = res.data.powerProtocol
        peizhi.value.dischargeCapacity = res.data.dischargeCapacity
        peizhi.value.chargeCapacity = res.data.chargeCapacity
        peizhi.value.ratedCapacity = res.data.ratedCapacity
        peizhi.value.createdAt = res.data.createdAt
        peizhi.value.scNum = res.data.scNum
        peizhi.value.enable485 = res.data.enable485
        peizhi.value.address485 = res.data.address485
        peizhi.value.protocol485 = res.data.protocol485
        peizhi.value.verify485 = res.data.verify485
        peizhi.value.stopBit485 = res.data.stopBit485
        peizhi.value.bit485 = res.data.bit485
        peizhi.value.bps485 = res.data.bps485


      });

    };

    onMounted(() => {
      //组件挂载时的生命周期执行的方法

      getData();
    });

    return {
      handleChange,
      onChange,
      onOk,
      onChange2,
      onOk2,

      onChange3,
      onOk3,
      onChange4,
      onOk4,

      onChange5,
      onOk5,
      onChange6,
      onOk6,

      onChange7,
      onOk7,
      onChange8,
      onOk8,

      onChange9,
      onOk9,
      onChange10,
      onOk10,

      onChange11,
      onOk11,
      onChange12,
      onOk12,

      onChange13,
      onOk13,
      onChange14,
      onOk14,

      onChange15,
      onOk15,
      onChange16,
      onOk16,

      getData,

      peizhi, clsz, dianyuan, baohu,
      value2: ref(), dateFormat,
      data,
      active,
      visible,
      showModal,
      handleOk,
      formState2,

      visible2,
      showModal2,
      handleOk2,
      formState3,

      visible11,
      showModal11,
      handleOk11,
      formState11,

      visible12,
      showModal12,
      handleOk12,
      formState12,

      visible13,
      showModal13,
      handleOk13,
      formState13,

      visible15,
      showModal15,
      handleOk15,
      formState15,
      fileList,
      headers, uploads,
      activeKey
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  padding: 0 40px;
  height: 100%;

}



.ant-input {
  color: #333 !important;
}

.ant-input-group .ant-input {
  color: #333 !important;
}


.nav ul {
  display: flex;
}

.nav ul li {
  color: #fff;
  list-style: none;
  background: url("@/assets/navbg2.png");
  width: 156px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  margin-right: 5px;

  font-size: 14px;
  font-weight: bold;
}

.nav ul li a {
  color: #fff;
}

.nav ul li.action {
  color: #00ffff;
}

.peizhi ul {
  display: flex;
  padding-top: 10px;
}

.peizhi ul li {
  list-style: none;
  background-color: #1d5fa3;
  color: #fff;
  margin-right: 15px;
  border: 1px #409eff solid;
  padding: 5px 15px;
  cursor: pointer;
}

:deep(.input-group .ant-form-item-control-input-content) {
  display: flex;
  flex-direction: row;
  align-items: center;
}

:deep(.ant-form-item-extra) {
  padding-top: 10px;
  color: rgb(255 255 255 / 45%);
}

:deep(span.ant-radio+*) {
  color: #ffffff !important;
}

:deep(.ant-tabs-top>.ant-tabs-nav::before) {
  border-bottom: 1px solid rgb(24 144 255 / 20%);
}

:deep(.ant-tabs-tab-btn) {
  color: #c1d4ff;
}

:deep(.ant-upload.ant-upload-select-picture-card>.ant-upload) {
  flex-direction: column !important;
}
</style>
